import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
import BaseCommand from './BaseCommand';
import { Component, ContextType, DropInPaymentsCommandNames, fireStatusUpdate, Namespace, PaymentMethodsCommandNames, StatusTypes } from '@chegg/commerce-utils';
import { savePaymentMethodsCommands } from '../../redux/command/command.slice';
import { saveCartInfo } from '../../redux/cart/cart.slice';
import { clearMessage } from '../../redux/message/message.slice';
export var BeginPlaceOrderCommand = /*#__PURE__*/function (_BaseCommand) {
  function BeginPlaceOrderCommand() {
    _classCallCheck(this, BeginPlaceOrderCommand);
    return _callSuper(this, BeginPlaceOrderCommand, arguments);
  }
  _inherits(BeginPlaceOrderCommand, _BaseCommand);
  return _createClass(BeginPlaceOrderCommand, [{
    key: "execute",
    value: function () {
      var _execute = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.dispatch(savePaymentMethodsCommands([{
                commandName: PaymentMethodsCommandNames.FETCH_PAYMENT_METHOD
              }]));
              this.dispatch(saveCartInfo({
                isCheckoutPending: true
              }));
              this.dispatch(clearMessage());
              fireStatusUpdate([{
                status: StatusTypes.PENDING,
                command: DropInPaymentsCommandNames.PLACE_ORDER_DISABLED,
                payload: {
                  component: Component.COMMAND_MANAGER,
                  context: ContextType.DROP_IN_PAYMENTS
                }
              }], Namespace.DROP_IN_PAYMENTS);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function execute() {
        return _execute.apply(this, arguments);
      }
      return execute;
    }()
  }]);
}(BaseCommand);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/dropin-payments/dist/esm/commandManager/commands/BeginPlaceOrderCommand.js
// module id = 4688
// module chunks = 11